import React from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {cn} from 'hec/lib/utils'

interface SiteToggleProps {
    className?: string
}

const SiteToggle = ({className}: SiteToggleProps) => {
    const config = getConfig()
    const threeLetter = config.app.threeLetter

    if (threeLetter !== 'FSA' && threeLetter !== 'HSA') {
        return null
    }

    const isFSA = threeLetter === 'FSA'

    const leftTab = isFSA
        ? {
              label: 'FSAstore.com',
              href: '/',
              active: true
          }
        : {
              label: 'FSAstore.com',
              href: 'https://fsastore.com/?utm_source=hsastore.com&utm_medium=referral&utm_campaign=tabbed_experience',
              active: false
          }

    const rightTab = isFSA
        ? {
              label: 'HSAstore.com',
              href: 'https://hsastore.com/?utm_source=fsastore.com&utm_medium=referral&utm_campaign=tabbed_experience',
              active: false
          }
        : {
              label: 'HSAstore.com',
              href: '/',
              active: true
          }

    const tabClass = (active: boolean) =>
        cn(
            'w-full text-center pt-[3px] lg:w-auto lg:text-inherit',
            active ? 'bg-white' : 'bg-[#CCCCCC]'
        )

    return (
        <div
            className={cn(
                `
                font-bold text-[14px] leading-[29px] h-8 w-full inline-flex
                lg:absolute lg:leading-8 lg:h-[35px] lg:left-[20px]
                lg:text-left lg:w-[200px] lg:z-[30]
                `,
                className
            )}
        >
            <div className={tabClass(leftTab.active)}>
                <a href={leftTab.href} className="block">
                    <span className="text-foreground px-[10px] inline-block w-full font-light">
                        {leftTab.label}
                    </span>
                </a>
            </div>

            <div className={tabClass(rightTab.active)}>
                <a href={rightTab.href} className="block">
                    <span className="text-foreground px-[10px] inline-block w-full font-light">
                        {rightTab.label}
                    </span>
                </a>
            </div>
        </div>
    )
}

export default SiteToggle
